import React from 'react';
import UsersTable from './table/UsersTable';
import { UsersUIProvider } from './context/UsersUIContext';
import { Card } from '../../../components';
import { Box } from '@mui/material';
import UsersHeader from './UsersHeader';

export default function Users () {
    return (
        <UsersUIProvider>
            <Box display='flex' flexDirection='column' justifyContent='center' className='pageContainerFluid--standalone'>
                <Box style={{ borderRadius: '0.308rem' }}>
                    <Card>
                        <UsersHeader />
                    </Card>
                </Box>
                <UsersTable />
            </Box>
        </UsersUIProvider>
    );
};
